import { useState } from "react"
import { ChevronLeft, ChevronRight, Star } from "lucide-react"
import image from "../../assets/images/Avatar-6.png"
import quote from "../../assets/images/Quote.png"

export default function Testimonials() {
    const [currentTestimonial, setCurrentTestimonial] = useState(0)

    const testimonials = [
        {
            id: 1,
            name: "Rizka Amalia",
            position: "Head of Ops",
            company: "TechCorp Solutions",
            avatar: image,
            rating: 4.8,
            testimonial:
                "We trained 40+ operations staff with E1X. Our task turnaround improved by 42%, and data errors dropped by 35%. The results were measurable and immediate.",
            metrics: {
                staffTrained: "40+",
                improvementRate: "42%",
                errorReduction: "35%",
            },
        },
        {
            id: 2,
            name: "Michael Johnson",
            position: "HR Director",
            company: "Global Finance Ltd",
            avatar: image,
            rating: 4.9,
            testimonial:
                "E1X Academy transformed our team's capabilities. The training was practical, engaging, and delivered immediate results. Our productivity increased by 38% within the first month.",
            metrics: {
                staffTrained: "60+",
                improvementRate: "38%",
                errorReduction: "28%",
            },
        },
        {
            id: 3,
            name: "Sarah Williams",
            position: "Operations Manager",
            company: "DataFlow Systems",
            avatar: image,
            rating: 4.7,
            testimonial:
                "The quality of training exceeded our expectations. Our analysts now work more efficiently, and we've seen a 45% reduction in project completion time.",
            metrics: {
                staffTrained: "25+",
                improvementRate: "45%",
                errorReduction: "30%",
            },
        },
    ]

    const nextTestimonial = () => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)
    }

    const prevTestimonial = () => {
        setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length)
    }

    const current = testimonials[currentTestimonial]

    return (
        <section className="py-16 bg-gray-50">
            <div className="container mx-auto px-4">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
                </div>

                {/* Testimonial Carousel */}
                <div className="relative max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-5 md:gap-[90px] py-[30px] px-[50px] bg-white rounded-[30px] shadow-lg">
                    <div className="">
                        <div className="text-center  p-4 ">
                            <div className="text-3xl md:text-4xl font-semibold text-[#34364A] mb-2">{current.rating}</div>
                            <div className="flex justify-center">
                                {[...Array(5)].map((_, i) => (
                                    <Star
                                        key={i}
                                        className={`w-4 h-4 ${i < Math.floor(current.rating) ? "fill-[#FFC700] text-[#FFC700]" : "text-gray-300"
                                            }`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="  p-0 md:p-12 ">
                        {/* Quote Icon */}
                        <div className="flex justify-left mb-3">
                            <img src={quote} alt="quote" className="w-16 h-16 hidden md:flex" />
                            {/* <Quote className="w-16 h-16 text-[#34364A]" /> */}
                        </div>

                        {/* Main Content */}
                        <div className="text-center">
                            {/* Profile */}
                            <div className="flex flex-row items-center justify-left gap-5 mb-[30px]">
                                <div className=" ">
                                    <img
                                        src={current.avatar || "/placeholder.svg"}
                                        alt={current.name}
                                        className="w-20 h-20 rounded-full object-cover"
                                    />
                                </div>

                                {/* Name and Position */}
                                <div className="">
                                    <h3 className="text-xl font-bold text-gray-900 mb-1">{current.name}</h3>
                                    <p className="text-gray-600">{current.position}</p>
                                    <p className="text-sm text-gray-500">{current.company}</p>
                                </div>
                            </div>

                            {/* Testimonial Text */}
                            <p className="text-lg text-[#34364A] leading-relaxed mb-8 text-left">
                                {current.testimonial}
                            </p>
                        </div>

                        {/* Navigation Arrows */}
                        <button
                            onClick={prevTestimonial}
                            className="absolute -left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
                            aria-label="Previous testimonial"
                        >
                            <ChevronLeft className="w-6 h-6 text-gray-600" />
                        </button>

                        <button
                            onClick={nextTestimonial}
                            className="absolute -right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
                            aria-label="Next testimonial"
                        >
                            <ChevronRight className="w-6 h-6 text-gray-600" />
                        </button>
                    </div>


                </div>

                {/* Dots Indicator */}
                <div className="flex justify-center gap-2 mt-8">
                    {testimonials.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentTestimonial(index)}
                            className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentTestimonial ? "bg-orange-500 w-8" : "bg-gray-300 hover:bg-gray-400"
                                }`}
                            aria-label={`Go to testimonial ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}
